import { API_URL_V1 } from "../constants";

export const storesAvailable = (lat: number, lng: number) =>
  `${API_URL_V1}/available-stores?lat=${lat}&lng=${lng}`;
